<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>链接管理</el-breadcrumb-item>
      <el-breadcrumb-item>链接列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="start_date"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
        </el-col>

        <el-col :span="4">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="end_date"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-col>

        <el-col :span="2">
           <el-button type="success" @click="getLinkList">按日期查询</el-button>
        </el-col>

        <el-col :span="5">
          <el-button type="primary" @click="dialogVisible = true">添加链接</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="mgoldlink">查看老链接</el-button>
        </el-col>
      </el-row>
      <el-table :data="linklist" stripe style="width:100%!important">
        <el-table-column label="#" type="index" width="60"></el-table-column>
        <el-table-column label="域名" prop="host_name" width="190"></el-table-column>
        <el-table-column label="短链接" prop="short_link" width="290"></el-table-column>
        <el-table-column label="长链接" prop="url" width="500"></el-table-column>
        <el-table-column label="创建日期" prop="add_date" width="100"></el-table-column>
        <el-table-column label="备注" prop="beizhu" width="210"></el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">

            <el-button @click="CopyLink(scope.row.short_link)" type="success" size="medium">拷贝短链</el-button>
            <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
            <el-button @click="ShowEditLink(scope.row.num)" type="primary" icon="el-icon-edit" size="medium"></el-button>
            </el-tooltip>

            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button @click="LinkDel(scope.row.num)" type="danger" icon="el-icon-delete" size="medium"></el-button>
            </el-tooltip>
            
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page_number"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allCount">
      </el-pagination>
    </el-card>

    <el-dialog
      title="添加短链接"
      :visible.sync="dialogVisible"
      width="50%">
      <el-form ref="addFormRef" :model="add_form" :rules="myrules" class="add_form">
            <!--用户名-->
            <el-form-item label="选择域名" prop="host_name">
               <el-select v-model="add_form.host_name" placeholder="请选择" v-if="ids==='1'">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="add_form.host_name" placeholder="请选择" v-if="ids==='2'">
                <el-option
                  v-for="item in options_01"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="add_form.host_name" placeholder="请选择" v-if="ids==='3'">
                <el-option
                  v-for="item in options_02"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="add_form.host_name" placeholder="请选择" v-if="ids==='4'">
                <el-option
                  v-for="item in options_03"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="add_form.host_name" placeholder="请选择" v-if="ids==='5'">
                <el-option
                  v-for="item in options_04"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
            <!--输入长链接-->
            <el-form-item label="输入长链接" prop="url">
               <el-input v-model="add_form.url"></el-input>
            </el-form-item>
            <!--备注-->
            <el-form-item label="备注" prop="beizhu">
               <el-input v-model="add_form.beizhu"></el-input>
            </el-form-item>
            <!--按钮-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDialogVisible">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改链接"
      :visible.sync="dialogEditLink"
      width="50%">
      <el-form ref="editFormRef" :model="edit_form" :rules="myrules" class="add_form">
            <!--用户名-->
            <el-form-item label="选择域名" prop="host_name">
               <el-select v-model="edit_form.host_name" placeholder="请选择" v-if="ids==='1'">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="edit_form.host_name" placeholder="请选择" v-if="ids==='2'">
                <el-option
                  v-for="item in options_01"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="edit_form.host_name" placeholder="请选择" v-if="ids==='3'">
                <el-option
                  v-for="item in options_02"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="edit_form.host_name" placeholder="请选择" v-if="ids==='4'">
                <el-option
                  v-for="item in options_03"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="edit_form.host_name" placeholder="请选择" v-if="ids==='5'">
                <el-option
                  v-for="item in options_04"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
            <!--密码-->
            <el-form-item label="输入长链接" prop="url">
               <el-input v-model="edit_form.url"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="beizhu">
               <el-input v-model="edit_form.beizhu"></el-input>
            </el-form-item>
            <!--按钮-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditLink = false">取 消</el-button>
        <el-button type="primary" @click="EditLinkConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      ids:window.sessionStorage.getItem('ids'),
      queryInfo:{
        page_number:1,
        page_size:5
      },
      start_date:'',
      end_date:'',
      linklist:[],
      allCount:0,
      dialogVisible:false,
      dialogEditLink:false,
      add_form:{
            host_name:'',
            url:'',
            beizhu:''
         },
      edit_form:{},
      myrules:{
        host_name:[
        {required:true,message:'请选择域名',trigger:'blur'},
        {min:3,max:20,message:'长度在 3 到 20 个字符',trigger:'blur'}   
        ],
        url:[
            {required:true,message:'请输入长链接',trigger:'blur'},
            {min:6,max:500,message:'长度在 6 到 500 个字符',trigger:'blur'}
        ]
      },
      options: [
        {
          value: 's.cheetahbeauty.com',
          label: 's.cheetahbeauty.com'
        }, 
        {
          value: 'w.grawwhair.com',
          label: 'w.grawwhair.com'
        }, 
        {
          value: 's.sterlyhair.com',
          label: 's.sterlyhair.com'
        }, 
        {
          value: 'w.mamushowhair.com',
          label: 'w.mamushowhair.com'
        }
      ],
      options_01: [
        {
          value: 's.cheetahbeauty.com',
          label: 's.cheetahbeauty.com'
        }
      ],
      options_02: [
        {
          value: 'w.grawwhair.com',
          label: 'w.grawwhair.com'
        }
      ],
      options_03: [
        {
          value: 's.sterlyhair.com',
          label: 's.sterlyhair.com'
        }
      ],
      options_04: [
        {
          value: 'w.mamushowhair.com',
          label: 'w.mamushowhair.com'
        }
      ]
    }
  },
  created(){
    this.getLinkList()
  },
  methods: {
    async getLinkList(){
      var page_number = this.queryInfo.page_number;
      var page_size = this.queryInfo.page_size;
      axios({
        method: "post",
        url: "http://144.202.120.54/api/ShortLinks/linkList",
        params: {
          ids:window.sessionStorage.getItem('ids'),
          page_number: page_number,
          page_size: page_size,
          start_date: this.start_date,
          end_date: this.end_date,
          token:window.sessionStorage.getItem('token')
        },
        headers: {
          Authorization:window.sessionStorage.getItem('token')
        }
      }).then((res) => {
          if(res.data.code == 0){
            this.$message.error('获取链接数据失败!');
            return false; 
          } 
          if(res.data.code ==200){
            this.linklist = res.data.data.link_Arr
            this.allCount = res.data.data.allCount          
          }
      });
    },
    mgoldlink(){
      this.$router.push('/linkago');
    },
    //监听pagesize改变事件
    handleSizeChange(newSize){
      console.log(newSize)
      this.queryInfo.page_size = newSize
      this.getLinkList()
    },
    handleCurrentChange(newPage){
      console.log(newPage)
      this.queryInfo.page_number = newPage
      this.getLinkList()
    },
    addDialogVisible(){
      const host_name = this.add_form.host_name;
      const url = this.add_form.url;
      if(host_name !='' && url !=''){
        this.AddLink();
        this.AddLinkClose();
      }
  
    },
    EditLinkConfirm(){
      this.EditWindowClose();
      this.EditLink();
    },
    EditLink(){
      this.$refs.editFormRef.validate(async valid=>{
         if(!valid) return;
           const formData = this.edit_form; // 获取表单数据
           axios({
              method: "post",
              url: "http://144.202.120.54/api/ShortLinks/editLink",
              params: {
                ids:window.sessionStorage.getItem('ids'),
                id: this.edit_form.num,
                host_name: this.edit_form.host_name,
                url: this.edit_form.url,
                beizhu: this.edit_form.beizhu,
                token:window.sessionStorage.getItem('token')
              },
            }).then((res) => {
          
                if(res.data.code == 0){
                  console.log(res.data.code);
                  this.$message.error('暂无更新!');
                  return false; 
                } 
                if(res.data.code ==200){
                  console.log(this.edit_form.num);
                  this.$message.success('更新成功');
                  setTimeout(function(){
                  location.reload();
                  },800);
                }
            });
         });  
    },
    AddLink(){
         this.$refs.addFormRef.validate(async valid=>{
         if(!valid) return;
           const formData = this.add_form; // 获取表单数据
           axios({
              method: "post",
              url: "http://144.202.120.54/api/ShortLinks/addLink",
              params: {
                ids:window.sessionStorage.getItem('ids'),
                host_name: this.add_form.host_name,
                url: this.add_form.url,
                beizhu:this.add_form.beizhu,
                token:window.sessionStorage.getItem('token')
              },
            }).then((res) => {
                console.log(res);
                if(res.data.code == 0){
                  console.log(res.data.code);
                  this.$message.error('此链接已添加过!');
                  return false;
                }
                if(res.data.code == 203){
                  console.log(res.data.code);
                  this.$message.error('添加失败!');
                  return false; 
                } 
                if(res.data.code ==200){
                  console.log(res.data.code);
                  this.$message.success('添加成功');
                  setTimeout(function(){
                  location.reload();
                  },1000);
                }
            });
         });
      },
    ShowEditLink(id){
      this.dialogEditLink = true;
      axios({
        method: "post",
        url: "http://144.202.120.54/api/ShortLinks/editLinkSearch",
        params: {
          ids:window.sessionStorage.getItem('ids'),
          id: id,
          token:window.sessionStorage.getItem('token')
        }
      }).then((res) => {

          if(res.data.code == 0){
            console.log(res.data.code);
            this.$message.error('无此数据!');
            return false;
          }

          if(res.data.code ==200){
            console.log(res.data.data);
            this.edit_form = res.data.data;
          }
      });
    },
    CopyLink(short_link){

      var input = document.createElement('input')
      input.value = short_link;
      document.body.appendChild(input);
      input.select();
      if(document.execCommand('copy')){
        this.$message.success('拷贝成功!');
        document.body.removeChild(input);
      }
    },
    AddLinkClose(){
      this.dialogVisible = false;
    },
    EditWindowClose(){
      this.dialogEditLink = false;
    },
   async LinkDel(id){
 
      const res = await this.$confirm('此操作将永久删除该短链, 是否继续?', '提示', 
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }
      ).catch(error => error)
      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel

      if(res !== 'confirm'){
        return  this.$message.info('已取消删除')
      }
   
      axios({
        method: "post",
        url: "http://144.202.120.54/api/ShortLinks/delLink",
        params: {
          ids:window.sessionStorage.getItem('ids'),
          id: id,
          token:window.sessionStorage.getItem('token')
        },
      }).then((res) => {
          console.log(res);

          if(res.data.code == 0){
            console.log(res.data.code);
            this.$message.error('删除失败!');
            return false;
          }

          if(res.data.code ==200){
            console.log(id);
            this.$message.success('删除成功');
            setTimeout(function(){
            location.reload();
            },1000);
          }
      });
    }
  }
}
</script>
<style lang="less" scoped>
  .el-pagination{margin-top: 15px;}
</style>